import Vue from "vue";
import cookie from "../lib/cookie";

export const setTrackEventLabel = (state, value) => {
  state.trackEventLabel = value;
};

export const getToken = (state) => {
  if (window.localStorage.getItem("token") !== null) {
    state.hasToken = true;
  }
};
export const clearToken = (state) => {
  window.localStorage.removeItem("token");
  window.localStorage.removeItem("userInfo");
  state.hasToken = false;
};
export const setCurrentLang = (state, lang) => {
  Vue.config.lang = lang;
  state.currentLang = lang;
  window.localStorage.setItem("currentLang", lang);
  switch (lang) {
    case "zh": {
      document.title = "Plex加速器 - 一款高速，安全，实用的加速器";
      break;
    }
    case "en": {
      document.title =
        "PlexVPN - A high speed, ultra secure, and easy to use VPN.";
      break;
    }
  }
  let curretcy = {
    zh: "CNY",
    en: "USD",
  };
  state.currentSymbol = curretcy[state.currentLang];
};
export const setDialCode = (state, value) => {
  state.dialCode = value;
};
export const setPhoneHeaderLogoFlag = (state, status) => {
  state.phoneHeaderLogoFlag = status;
};
export const setCurrentPackage = (state, packageInfo) => {
  state.currentPackage = packageInfo;
};
export const setCurrentPayment = (state, payment) => {
  state.currentPaymentMethod = payment;
};
export const setNeedAuthorization = (state, need) => {
  state.needAuthorization = need;
};
export const setFlagList = (state, value) => {
  state.flagList.push(value);
};
export const resetDefaultActiveLink = (state) => {
  for (let link in state.defaultActiveLink) {
    state.defaultActiveLink[link] = false;
  }
};
export const setDefaultActiveLink = (state, defaultValue) => {
  state.defaultActiveLink[defaultValue] = true;
};
export const setIsOpenLeftSidebar = (state, status) => {
  state.isOpenLeftSidebar = status;
};
export const setClientRedirectUrl = (state, url) => {
  state.redirectUrl = url;
};
export const setPauseServeInfo = (state, info) => {
  state.pauseServeInfo = info;
};
export const setIsHeader = (state, info) => {
  state.isHeader = info;
};
export const setStripe = (state, info) => {
  state.stripe = info;
};
export const setCard = (state, info) => {
  state.card = info;
};
export const setCardError = (state, info) => {
  state.cardError = info;
};
export const setCardNumberEmpty = (state, info) => {
  state.cardNumberEmpty = info;
};
export const setNameError1 = (state, info) => {
  state.nameError1 = info;
};
export const setClickIndexPagePackageData = (state, data) => {
  state.clickIndexPagePackageData = data;
};



// WEBPACK FOOTER //
// ./src/store/mutations.js